import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTariffDetailsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTariffDetailsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly subscription: { readonly __typename?: 'YalperSubscription', readonly planId?: number | null, readonly isTrial: boolean, readonly endDate?: string | null, readonly tariffDetails?: { readonly __typename?: 'BillingTariff', readonly key: string, readonly name: string, readonly spentMax?: number | null, readonly maxSubAccounts?: number | null, readonly maxAiReportRuns?: number | null, readonly aiReportsUnitPrice: number } | null }, readonly aiReportsLimit: { readonly __typename?: 'AiReportsLimit', readonly remainingReports?: number | null } } | null };


export const GetTariffDetailsDocument = gql`
    query GetTariffDetails {
  currentUser {
    subscription {
      planId
      isTrial
      endDate
      tariffDetails {
        key
        name
        spentMax
        maxSubAccounts
        maxAiReportRuns
        aiReportsUnitPrice
      }
    }
    aiReportsLimit {
      remainingReports
    }
  }
}
    `;

/**
 * __useGetTariffDetailsQuery__
 *
 * To run a query within a React component, call `useGetTariffDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTariffDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTariffDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTariffDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetTariffDetailsQueryPage, GetTariffDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTariffDetailsQueryPage, GetTariffDetailsQueryVariables>(GetTariffDetailsDocument, options);
      }
export function useGetTariffDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTariffDetailsQueryPage, GetTariffDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTariffDetailsQueryPage, GetTariffDetailsQueryVariables>(GetTariffDetailsDocument, options);
        }
export function useGetTariffDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTariffDetailsQueryPage, GetTariffDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTariffDetailsQueryPage, GetTariffDetailsQueryVariables>(GetTariffDetailsDocument, options);
        }
export type GetTariffDetailsQueryHookResult = ReturnType<typeof useGetTariffDetailsQuery>;
export type GetTariffDetailsLazyQueryHookResult = ReturnType<typeof useGetTariffDetailsLazyQuery>;
export type GetTariffDetailsSuspenseQueryHookResult = ReturnType<typeof useGetTariffDetailsSuspenseQuery>;
export type GetTariffDetailsQueryResult = Apollo.QueryResult<GetTariffDetailsQueryPage, GetTariffDetailsQueryVariables>;